import React, { useState, useEffect, useRef } from "react";
import axios from "axios";

const MultiSelectCheckbox = ({ options, selectedValues, onChange, onLoad }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const ref = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const toggleValue = (value) => {
    if (selectedValues.includes(value)) {
      onChange(selectedValues.filter((x) => x !== value));
    } else {
      onChange([...selectedValues, value]);
    }
  };

  const toggleSelectAll = () => {
    if (selectedValues.length === options.length) onChange([]);
    else onChange(options.map((o) => o.value));
  };

  return (
    <div className="ms-container" ref={ref}>
      {/* --- SELECT BOX --- */}
      <div className="ms-box" onClick={() => setIsOpen(!isOpen)}>
        {selectedValues.length === 0
          ? "Select Variant"
          : selectedValues.length === options.length
          ? "All Selected"
          : `${selectedValues.length} Selected`}
        <span className="ms-arrow">▼</span>
      </div>

      {/* --- DROPDOWN --- */}
      {isOpen && (
        <div className="ms-dropdown">
          {/* SEARCH BOX */}
          <input
            type="text"
            className="ms-search"
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          {/* SELECT ALL */}
          <div className="ms-item">
            <input
              type="checkbox"
              checked={selectedValues.length === options.length}
              onChange={toggleSelectAll}
            />
            <label>SELECT ALL</label>
          </div>

          {/* OPTIONS LIST */}
          <div className="ms-list">
            {options
              .filter((o) =>
                o.label.toLowerCase().includes(search.toLowerCase())
              )
              .map((o) => (
                <div className="ms-item" key={o.value}>
                  <input
                    type="checkbox"
                    checked={selectedValues.includes(o.value)}
                    onChange={() => toggleValue(o.value)}
                  />
                  <label>{o.label}</label>
                </div>
              ))}
          </div>

          {/* LOAD BUTTON */}
          <button
            className="ms-load"
            onClick={() => {
              if (onLoad) onLoad(selectedValues.map((v) => String(v)));
            }}
          >
            Load
          </button>
        </div>
      )}

      {/* --- CSS --- */}
      <style>{`
        .ms-container { position: relative; width: 100%; }

        .ms-box {
          border: 1px solid #b3b3b3;
          height: 29px;
          padding: 5px 10px;
          background: white;
          border-radius: 4px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          font-size: 14px;
        }

        .ms-arrow { font-size: 12px; }

        .ms-dropdown {
          position: absolute;
          width: 94%;
          background: white;
          border: 1px solid #ccc;
          margin-top: 2px;
          border-radius: 4px;
          z-index: 99999;
          padding: 5px 10px;
        }

        .ms-search {
          width: 100%;
          padding: 5px;
          font-size: 13px;
          margin-bottom: 5px;
          border: 1px solid #ccc;
          border-radius: 3px;
        }

        .ms-list {
          max-height: 200px;
          overflow-y: auto;
          border-top: 1px solid #eee;
          margin-top: 5px;
          padding-top: 5px;
        }

   .ms-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 0;
  font-size: 13px;
  cursor: pointer;
}

.ms-item input[type='checkbox'] {
  width: 14px !important;
  height: 14px !important;
  margin: 0;
  padding: 0;
  cursor: pointer;
}

.ms-item label {
  margin: 0;
  padding: 0;
  cursor: pointer;
  font-size: 13px;
  line-height: 14px;
}


        .ms-load {
          margin-top: 10px;
          width: 100%;
          background: #0f9dbd;
          color: white;
          border: none;
          padding: 6px;
          border-radius: 4px;
          cursor: pointer;
        }
      `}</style>
    </div>
  );
};

export default MultiSelectCheckbox;
